import React, { useEffect, useState } from "react";
import {
  fetchProducts,
  deleteProduct,
  updateProduct,
  createProduct,
} from "../../apiComponents/api-products";

import { uploadImage } from "../../apiComponents/api-image";

import ProductTable from "../../ui/ProductTable";
import ProductForm from "../../ui/ProductForm";
import ProductEditModal from "../../ui/ProductEditModal";
import Button from "../../ui/Button";

const MenuManagementPage = () => {
  const [products, setProducts] = useState([]);

  const [editingProduct, setEditingProduct] = useState(null);

  const [addingNew, setAddingNew] = useState(false);

  const [newProductData, setNewProductData] = useState({
    name: "",
    price: "",
    image1: null,
    image2: null,
    image3: null,
    image4: null,
    image5: null,
    description: "",
    contact_phone: "",
    contact_whatsapp: "",
    listing_type: "sale",
  });

  const [uploadingImage, setUploadingImage] = useState(false);

  const loadProducts = async () => {
    const data = await fetchProducts();
    if (data) setProducts(data);
  };

  useEffect(() => {
    loadProducts();
  }, []);

  const handleAddProduct = async () => {
    // Only Image 1 is required
    if (!newProductData.image1) {
      alert("Please select Image 1.");
      return;
    }

    try {
      setUploadingImage(true);

      // Upload Image 1
      const image1Url = await uploadImage(newProductData.image1);

      // Upload optional images only if they exist
      const image2Url = newProductData.image2
        ? await uploadImage(newProductData.image2)
        : null;

      const image3Url = newProductData.image3
        ? await uploadImage(newProductData.image3)
        : null;

      const image4Url = newProductData.image4
        ? await uploadImage(newProductData.image4)
        : null;

      const image5Url = newProductData.image5
        ? await uploadImage(newProductData.image5)
        : null;

      await createProduct({
        name: newProductData.name,
        price: newProductData.price,

        image1: image1Url,
        image2: image2Url,
        image3: image3Url,
        image4: image4Url,
        image5: image5Url,

        description: newProductData.description,
        contact_phone: newProductData.contact_phone,
        contact_whatsapp: newProductData.contact_whatsapp,

        listing_type: newProductData.listing_type,
      });

      setAddingNew(false);

      setNewProductData({
        name: "",
        price: "",
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        image5: null,
        description: "",
        contact_phone: "",
        contact_whatsapp: "",
        listing_type: "sale",
      });

      await loadProducts();

    } catch (error) {
      console.error("Error adding product:", error);
      alert("Something went wrong while uploading the product.");
    } finally {
      setUploadingImage(false);
    }
  };

  const handleSaveEdit = async (id, updatedData) => {
    await updateProduct(id, updatedData);
    setEditingProduct(null);
    loadProducts();
  };

  return (
    <div className="p-4 md:p-10 max-w-7xl mx-auto">

      <h1 className="text-2xl md:text-3xl font-bold text-center mb-6">
        Menu Management
      </h1>

      {!addingNew && (
        <Button onClick={() => setAddingNew(true)}>
          Add Menu Item
        </Button>
      )}

      {addingNew && (
        <ProductForm
          form={newProductData}

          onChange={(e) =>
            setNewProductData({
              ...newProductData,
              [e.target.name]: e.target.value,
            })
          }

          onFile={(e, imageField) =>
            setNewProductData({
              ...newProductData,
              [imageField]: e.target.files[0],
            })
          }

          onSubmit={handleAddProduct}

          onCancel={() => setAddingNew(false)}

          loading={uploadingImage}
        />
      )}

      <ProductTable
        products={products}
        onEdit={(product) => setEditingProduct(product)}
        onDelete={async (id) => {
          await deleteProduct(id);
          loadProducts();
        }}
      />

      {/* EDIT MODAL */}
      <ProductEditModal
        product={editingProduct}
        onClose={() => setEditingProduct(null)}
        onSave={handleSaveEdit}
      />

    </div>
  );
};

export default MenuManagementPage;
